module.exports = __webpack_public_path__ + "img/img_level_21.fba5f82a.png";